<div class="library-content">
  <div class="library-tabs-container">
    <ddc-tabs-chips
      [tabs]="[
        { key: 'overview', label: 'Overview', icon: _iconNames.OVERVIEW, selected: _tabUI.overview.isSelected },
        { key: 'words', label: 'Words', icon: _iconNames.WORD, selected: _tabUI.words.isSelected },
        { key: 'pairs', label: 'Pairs', icon: _iconNames.PAIR, selected: _tabUI.pairs.isSelected },
        {
          key: 'dictionaries',
          label: 'Dictionaries',
          icon: _iconNames.DICTIONARY,
          selected: _tabUI.dictionaries.isSelected,
        },
        { key: 'notes', label: 'Notes', icon: _iconNames.NOTE, selected: _tabUI.notes.isSelected },
        { key: 'quizzes', label: 'Quizzes', icon: _iconNames.QUIZ, selected: _tabUI.quizzes.isSelected },
        { key: 'figures', label: 'Figures', icon: _iconNames.FIGURE, selected: _tabUI.figures.isSelected },
        { key: 'pdfs', label: 'PDFs', icon: _iconNames.PDF, selected: _tabUI.pdfs.isSelected },
        { key: 'categories', label: 'Categories', icon: _iconNames.CATEGORY, selected: _tabUI.categories.isSelected },
        { key: 'tags', label: 'Tags', icon: _iconNames.TAG, selected: _tabUI.tags.isSelected },
      ]"
      [theme]="_isLightTheme ? 'light' : _isDarkTheme ? 'dark' : 'paper'"
      (tabClick)="clickedChip($event)"
    ></ddc-tabs-chips>
  </div>
  <div class="library-content-container">
    @if (
      _tabUI.words.isLoading ||
      _tabUI.pairs.isLoading ||
      _tabUI.dictionaries.isLoading ||
      _tabUI.notes.isLoading ||
      _tabUI.quizzes.isLoading ||
      _tabUI.figures.isLoading ||
      _tabUI.pdfs.isLoading ||
      _tabUI.categories.isLoading ||
      _tabUI.tags.isLoading
    ) {
      <div class="loading-container">
        <ddc-loading-skeleton></ddc-loading-skeleton>
      </div>
    } @else {
      <!-- ! Overview -->
      <div class="lib-overview-container" *ngIf="_tabUI.overview.isSelected">
        <div class="lib-overview-holder" *ngIf="!_tabUI.overview.isLoading">
          <!-- o-words -->
          <div
            class="overview-w-cont"
            [ngClass]="{
              'ddc-home-card-light-1': _isLightTheme,
              'ddc-home-card-dark-1': _isDarkTheme,
              'ddc-home-card-paper-1': _isPaperTheme,
            }"
            (click)="dashboardElementClicked('words')"
          >
            <div class="overview-w-label">
              <span class="material-icons ddc-chip-icon"> fiber_manual_record </span>
              <div>Words</div>
            </div>
            <div class="overview-w-number">{{ _totalCounts['words'] || 0 }}</div>
            <div class="overview-w-lastest" *ngIf="_lastUpdated['words']">Latest:</div>
            <ddc-small-word
              *ngIf="_lastUpdated['words']"
              [with_icon]="false"
              [word]="_lastUpdated['words']"
            ></ddc-small-word>
          </div>
          <!-- o-pairs -->
          <div
            class="overview-p-cont"
            [ngClass]="{
              'ddc-home-card-light-1': _isLightTheme,
              'ddc-home-card-dark-1': _isDarkTheme,
              'ddc-home-card-paper-1': _isPaperTheme,
            }"
            (click)="dashboardElementClicked('pairs')"
          >
            <div class="overview-p-label">
              <span class="material-icons ddc-chip-icon"> fiber_smart_record </span>
              <div>Pairs</div>
            </div>
            <div class="overview-p-number">{{ _totalCounts['pairs'] || 0 }}</div>
            <div class="overview-p-lastest" *ngIf="_lastUpdated['pairs']">Latest:</div>
            <ddc-small-pair
              *ngIf="_lastUpdated['pairs']"
              [pair]="_lastUpdated['pairs']"
              [with_icon]="false"
            ></ddc-small-pair>
          </div>
          <!-- o-dic -->
          <div
            class="overview-d-cont"
            [ngClass]="{
              'ddc-home-card-light-2': _isLightTheme,
              'ddc-home-card-dark-2': _isDarkTheme,
              'ddc-home-card-paper-2': _isPaperTheme,
            }"
            (click)="dashboardElementClicked('dics')"
          >
            <div class="overview-d-label">
              <span class="material-icons ddc-chip-icon"> auto_stories </span>
              <div>Dictionaries</div>
            </div>
            <div class="overview-d-number">{{ _totalCounts['dictionaries'] || 0 }}</div>
            <div class="overview-d-lastest" *ngIf="_lastUpdated['dictionaries']">Latest:</div>
            <ddc-small-word
              *ngIf="_lastUpdated['dictionaries']"
              [with_icon]="false"
              [word]="_lastUpdated['dictionaries']"
            ></ddc-small-word>
          </div>

          <!-- o-notes -->
          <div
            class="overview-note-cont"
            [ngClass]="{
              'ddc-home-card-light-2': _isLightTheme,
              'ddc-home-card-dark-2': _isDarkTheme,
              'ddc-home-card-paper-2': _isPaperTheme,
            }"
            (click)="dashboardElementClicked('notes')"
          >
            <div class="overview-note-label">
              <span class="material-icons ddc-chip-icon"> text_snippet </span>
              <div>Notes</div>
            </div>
            <div class="overview-note-number">{{ _totalCounts['notes'] || 0 }}</div>
            <div class="overview-note-lastest" *ngIf="_lastUpdated['notes']">Latest:</div>
            <ddc-small-word
              *ngIf="_lastUpdated['notes']"
              [with_icon]="false"
              [word]="_lastUpdated['notes']"
            ></ddc-small-word>
          </div>
          <!-- o-quizzes -->
          <div
            class="overview-quiz-cont"
            [ngClass]="{
              'ddc-home-card-light-2': _isLightTheme,
              'ddc-home-card-dark-2': _isDarkTheme,
              'ddc-home-card-paper-2': _isPaperTheme,
            }"
            (click)="dashboardElementClicked('quizzes')"
          >
            <div class="overview-quiz-label">
              <span class="material-icons ddc-chip-icon"> question_answer </span>
              <div>Quizzes</div>
            </div>
            <div class="overview-quiz-number">{{ _totalCounts['quizzes'] || 0 }}</div>
            <div class="overview-quiz-lastest" *ngIf="_lastUpdated['quizzes']">Latest:</div>
            <ddc-small-word
              *ngIf="_lastUpdated['quizzes']"
              [with_icon]="false"
              [word]="_lastUpdated['quizzes']"
            ></ddc-small-word>
          </div>

          <!-- o-figures -->
          <div
            class="overview-figure-cont"
            [ngClass]="{
              'ddc-home-card-light-2': _isLightTheme,
              'ddc-home-card-dark-2': _isDarkTheme,
              'ddc-home-card-paper-2': _isPaperTheme,
            }"
            (click)="dashboardElementClicked('figures')"
          >
            <div class="overview-figure-label">
              <span class="material-icons ddc-chip-icon"> hub </span>
              <div>Figures</div>
            </div>
            <div class="overview-figure-number">{{ _totalCounts['figures'] || 0 }}</div>
            <div class="overview-figure-lastest" *ngIf="_lastUpdated['figures']">Latest:</div>
            <ddc-small-word
              *ngIf="_lastUpdated['figures']"
              [with_icon]="false"
              [word]="_lastUpdated['figures']"
            ></ddc-small-word>
          </div>
          <!-- o-pdfs -->
          <div
            class="overview-t-cont"
            [ngClass]="{
              'ddc-home-card-light-3': _isLightTheme,
              'ddc-home-card-dark-3': _isDarkTheme,
              'ddc-home-card-paper-3': _isPaperTheme,
            }"
            (click)="dashboardElementClicked('pdfs')"
          >
            <div class="overview-t-label">
              <span class="material-icons ddc-chip-icon"> print </span>
              <div>PDFs</div>
            </div>
            <div class="overview-d-lastest">Generated PDF documents</div>
            <div class="overview-d-lastest" style="font-size: 10px; margin-top: 20px">Daydic Prints</div>
          </div>
          <!-- o-cats -->
          <div
            class="overview-c-cont"
            [ngClass]="{
              'ddc-home-card-light-4': _isLightTheme,
              'ddc-home-card-dark-4': _isDarkTheme,
              'ddc-home-card-paper-4': _isPaperTheme,
            }"
            (click)="dashboardElementClicked('cats')"
          >
            <div class="overview-c-label">
              <span class="material-icons ddc-chip-icon"> category </span>
              <div>Categories</div>
            </div>
            <div class="overview-c-number">{{ _totalCounts['categories'] || 0 }}</div>
            <!-- <div class="overview-c-lastest">Latest: "{{ _ovLastUpdatedCategory }}"</div> -->
            <div class="overview-d-lastest" *ngIf="_lastUpdated['categories']">Latest:</div>
            <ddc-small-word
              *ngIf="_lastUpdated['categories']"
              [with_icon]="false"
              [word]="_lastUpdated['categories']"
            ></ddc-small-word>
          </div>
          <!-- o-tags -->
          <div
            class="overview-t-cont"
            [ngClass]="{
              'ddc-home-card-light-4': _isLightTheme,
              'ddc-home-card-dark-4': _isDarkTheme,
              'ddc-home-card-paper-4': _isPaperTheme,
            }"
            (click)="dashboardElementClicked('tags')"
          >
            <div class="overview-t-label">
              <span class="material-icons ddc-chip-icon"> tag </span>
              <div>Tags</div>
            </div>
            <div class="overview-t-number">{{ _totalCounts['tags'] || 0 }}</div>
            <div class="overview-d-lastest" *ngIf="_lastUpdated['tags']">Latest:</div>
            <ddc-small-word
              *ngIf="_lastUpdated['tags']"
              [with_icon]="false"
              [word]="_lastUpdated['tags']"
            ></ddc-small-word>
          </div>
        </div>

        <!-- ECharts Line Stat Components - Dummy Data -->
        <div class="line-charts-container" *ngIf="_tabUI.overview.isSelected && !_tabUI.overview.isLoading">
          <div
            class="line-chart-card"
            [ngClass]="{
              'ddc-home-card-light-stat': _isLightTheme,
              'ddc-home-card-dark-stat': _isDarkTheme,
              'ddc-home-card-paper-stat': _isPaperTheme,
            }"
          >
            <ddc-stat-line-chart
              title="Dictionaries"
              [data]="_dictionariesLastYearData"
              [theme]="_isLightTheme ? 'light-theme' : _isDarkTheme ? 'dark-theme' : 'paper-theme'"
            >
            </ddc-stat-line-chart>
          </div>
          <div
            class="line-chart-card"
            [ngClass]="{
              'ddc-home-card-light-stat': _isLightTheme,
              'ddc-home-card-dark-stat': _isDarkTheme,
              'ddc-home-card-paper-stat': _isPaperTheme,
            }"
          >
            <ddc-stat-line-chart
              title="Notes"
              [data]="_notesLastYearData"
              [theme]="_isLightTheme ? 'light-theme' : _isDarkTheme ? 'dark-theme' : 'paper-theme'"
            >
            </ddc-stat-line-chart>
          </div>
          <div
            class="line-chart-card"
            [ngClass]="{
              'ddc-home-card-light-stat': _isLightTheme,
              'ddc-home-card-dark-stat': _isDarkTheme,
              'ddc-home-card-paper-stat': _isPaperTheme,
            }"
          >
            <ddc-stat-line-chart
              title="Figures"
              [data]="_figuresLastYearData"
              [theme]="_isLightTheme ? 'light-theme' : _isDarkTheme ? 'dark-theme' : 'paper-theme'"
            >
            </ddc-stat-line-chart>
          </div>
          <div
            class="line-chart-card"
            [ngClass]="{
              'ddc-home-card-light-stat': _isLightTheme,
              'ddc-home-card-dark-stat': _isDarkTheme,
              'ddc-home-card-paper-stat': _isPaperTheme,
            }"
          >
            <ddc-stat-line-chart
              title="Quizzes"
              [data]="_quizzesLastYearData"
              [theme]="_isLightTheme ? 'light-theme' : _isDarkTheme ? 'dark-theme' : 'paper-theme'"
            >
            </ddc-stat-line-chart>
          </div>
        </div>

        <div class="square-divs" *ngIf="_tabUI.overview.isLoading" style="display: flex">
          <ddc-loading-skeleton></ddc-loading-skeleton>
        </div>
      </div>
      <!-- ! Words -->
      <div class="lib-words-container" *ngIf="_tabUI.words.isSelected">
        <!-- ! Word Content -->
        <div class="words-content" [class.gray-out]="_isInputActive">
          <div class="word-content-main" *ngIf="!_tabUI.words.isLoading">
            <div
              infiniteScroll
              [infiniteScrollDistance]="1"
              [infiniteScrollThrottle]="500"
              (scrolled)="onWordsScroll()"
            >
              <div *ngFor="let word of _words; let i = index" style="margin: 10px">
                <ddc-content-card
                  [content]="word"
                  (bookmarkChanged)="updateWordBookmark($event, i)"
                  (clicked)="openReadDialog('words', i)"
                  (deleteClicked)="openDeleteDialog('words', i)"
                  (editClicked)="openItemEditDialog('words', i)"
                ></ddc-content-card>
              </div>
            </div>
            <!-- Info at bottom -->
            <div class="word-info-label" *ngIf="_totalCounts['words'] > 10">
              <ng-lottie
                *ngIf="!_tabUI.words.end && !_tabUI.words.scrollLoading"
                width="30px"
                [options]="scroll_options"
              ></ng-lottie>
              <ng-lottie *ngIf="_tabUI.words.scrollLoading" width="50px" [options]="loading_options"></ng-lottie>
              <mat-icon *ngIf="_tabUI.words.end && !_tabUI.words.scrollLoading">fact_check</mat-icon>&nbsp;&nbsp;{{
                _tabUI.words.pageInfoLabel
              }}
            </div>
            <!-- No words -->
            <ddc-not-available *ngIf="_words && _words.length === 0" [_elem]="'Word'"></ddc-not-available>
          </div>
        </div>
        <!-- ! Words loading -->
        <div class="elem-skeletons" *ngIf="_tabUI.words.isLoading">
          <ddc-loading-skeleton></ddc-loading-skeleton>
        </div>
        <div *ngIf="_tabUI.words.isEmpty">{{ _tabUI.words.fetchError }}</div>
      </div>
      <!-- ! Pairs -->
      <div class="lib-pairs-container" *ngIf="_tabUI.pairs.isSelected">
        <div class="pairs-content" [class.gray-out]="_isInputActive">
          <div class="pair-content-main" *ngIf="!_tabUI.pairs.isLoading">
            <div
              infiniteScroll
              [infiniteScrollDistance]="1"
              [infiniteScrollThrottle]="500"
              (scrolled)="onPairsScroll()"
            >
              <div *ngFor="let pair of _pairs; let i = index" style="margin: 10px">
                <ddc-content-card
                  [content]="pair"
                  (clicked)="openReadDialog('pairs', i)"
                  (deleteClicked)="openDeleteDialog('pairs', i)"
                  (editClicked)="openItemEditDialog('pairs', i)"
                ></ddc-content-card>
              </div>
            </div>
            <!-- Info at bottom -->
            <div class="pair-info-label" *ngIf="_totalCounts['pairs'] > 10">
              <ng-lottie
                *ngIf="!_tabUI.pairs.end && !_tabUI.pairs.scrollLoading"
                width="30px"
                [options]="scroll_options"
              ></ng-lottie>
              <ng-lottie *ngIf="_tabUI.pairs.scrollLoading" width="50px" [options]="loading_options"></ng-lottie>
              <mat-icon *ngIf="_tabUI.pairs.end && !_tabUI.pairs.scrollLoading">fact_check</mat-icon>&nbsp;&nbsp;{{
                _tabUI.pairs.pageInfoLabel
              }}
            </div>
            <!-- No pairs -->
            <ddc-not-available *ngIf="_pairs && _pairs.length === 0" [_elem]="'Pair'"></ddc-not-available>
          </div>
        </div>
        <!-- ! Pairs loading -->
        <div class="elem-skeletons" *ngIf="_tabUI.pairs.isLoading">
          <ddc-loading-skeleton></ddc-loading-skeleton>
        </div>
        <div *ngIf="_tabUI.pairs.isEmpty">{{ _tabUI.pairs.fetchError }}</div>
      </div>

      <!-- ! Dictionaries -->
      <div class="lib-dictionaries-container" *ngIf="_tabUI.dictionaries.isSelected">
        <div class="dictionaries-content" [class.gray-out]="_isInputActive">
          <div class="dictionaries-content-main" *ngIf="!_tabUI.dictionaries.isLoading">
            <div
              infiniteScroll
              [infiniteScrollDistance]="1"
              [infiniteScrollThrottle]="500"
              (scrolled)="onDictionariesScroll()"
            >
              <div
                *ngFor="let dictionary of _dictionaries; let i = index"
                [style.margin]="i === 0 ? '10px' : '0 10px 10px 10px'"
              >
                <ddc-content-card
                  [content]="dictionary"
                  [dynamicRoute]="'/library/dic/' + dictionary.id + '/' + dictionary.owner.username"
                  (deleteClicked)="openDeleteDialog('dictionaries', i)"
                ></ddc-content-card>
              </div>
            </div>
            <!-- Info at bottom -->
            <div class="dictionary-info-label" *ngIf="_totalCounts['dictionaries'] > 10">
              <ng-lottie
                *ngIf="!_tabUI.dictionaries.end && !_tabUI.dictionaries.scrollLoading"
                width="30px"
                [options]="scroll_options"
              ></ng-lottie>
              <ng-lottie *ngIf="_tabUI.dictionaries.scrollLoading" width="50px" [options]="loading_options"></ng-lottie>
              <mat-icon *ngIf="_tabUI.dictionaries.end && !_tabUI.dictionaries.scrollLoading">fact_check</mat-icon
              >&nbsp;&nbsp;{{ _tabUI.dictionaries.pageInfoLabel }}
            </div>
            <!-- No _dictionaries -->
            <ddc-not-available *ngIf="_dictionaries.length === 0" [_elem]="'Dictionary'"></ddc-not-available>
          </div>
        </div>
        <div class="elem-skeletons" *ngIf="_tabUI.dictionaries.isLoading">
          <ddc-loading-skeleton></ddc-loading-skeleton>
        </div>
        <div *ngIf="_tabUI.dictionaries.isEmpty">{{ _tabUI.dictionaries.fetchError }}</div>
      </div>

      <!-- ! Notes -->
      <div class="lib-notes-container" *ngIf="_tabUI.notes.isSelected">
        <div class="notes-content" [class.gray-out]="_isInputActive">
          <div class="notes-content-main" *ngIf="!_tabUI.notes.isLoading">
            <div
              infiniteScroll
              [infiniteScrollDistance]="1"
              [infiniteScrollThrottle]="500"
              (scrolled)="onNotesScroll()"
            >
              <div *ngFor="let note of _notes; let i = index" [style.margin]="i === 0 ? '10px' : '0 10px 10px 10px'">
                <ddc-content-card
                  [content]="note"
                  (bookmarkChanged)="updateNoteBookmark($event, i)"
                  (clicked)="openReadDialog('notes', i)"
                ></ddc-content-card>
              </div>
            </div>
            <!-- Info at bottom -->
            <div class="note-info-label" *ngIf="_totalCounts['notes'] > 10">
              <ng-lottie
                *ngIf="!_tabUI.notes.end && !_tabUI.notes.scrollLoading"
                width="30px"
                [options]="scroll_options"
              ></ng-lottie>
              <ng-lottie *ngIf="_tabUI.notes.scrollLoading" width="50px" [options]="loading_options"></ng-lottie>
              <mat-icon *ngIf="_tabUI.notes.end && !_tabUI.notes.scrollLoading">fact_check</mat-icon>&nbsp;&nbsp;{{
                _tabUI.notes.pageInfoLabel
              }}
            </div>
            <!-- No _notes -->
            <ddc-not-available *ngIf="_notes.length === 0" [_elem]="'Note'"></ddc-not-available>
          </div>
        </div>
        <div class="elem-skeletons" *ngIf="_tabUI.notes.isLoading">
          <ddc-loading-skeleton></ddc-loading-skeleton>
        </div>
        <div *ngIf="_tabUI.notes.isEmpty">{{ _tabUI.notes.fetchError }}</div>
      </div>

      <!-- ! Quizzes -->
      <div class="lib-quizzes-container" *ngIf="_tabUI.quizzes.isSelected">
        <div class="quizzes-content" [class.gray-out]="_isInputActive">
          <div class="quizzes-content-main" *ngIf="!_tabUI.quizzes.isLoading">
            <div
              infiniteScroll
              [infiniteScrollDistance]="1"
              [infiniteScrollThrottle]="500"
              (scrolled)="onQuizzesScroll()"
            >
              <div *ngFor="let quiz of _quizzes; let i = index" [style.margin]="i === 0 ? '10px' : '0 10px 10px 10px'">
                <ddc-content-card
                  [content]="quiz"
                  (bookmarkChanged)="updateQuizBookmark($event, i)"
                  (clicked)="openReadDialog('quizzes', i)"
                ></ddc-content-card>
              </div>
            </div>
            <!-- Info at bottom -->
            <div class="quiz-info-label" *ngIf="_totalCounts['quizzes'] > 10">
              <ng-lottie
                *ngIf="!_tabUI.quizzes.end && !_tabUI.quizzes.scrollLoading"
                width="30px"
                [options]="scroll_options"
              ></ng-lottie>
              <ng-lottie *ngIf="_tabUI.quizzes.scrollLoading" width="50px" [options]="loading_options"></ng-lottie>
              <mat-icon *ngIf="_tabUI.quizzes.end && !_tabUI.quizzes.scrollLoading">fact_check</mat-icon>&nbsp;&nbsp;{{
                _tabUI.quizzes.pageInfoLabel
              }}
            </div>
            <!-- No _quizzes -->
            <ddc-not-available *ngIf="_quizzes.length === 0" [_elem]="'Quiz'"></ddc-not-available>
          </div>
        </div>
        <div class="elem-skeletons" *ngIf="_tabUI.quizzes.isLoading">
          <ddc-loading-skeleton></ddc-loading-skeleton>
        </div>
        <div *ngIf="_tabUI.quizzes.isEmpty">{{ _tabUI.quizzes.fetchError }}</div>
      </div>

      <!-- ! Figures -->
      <div class="lib-figures-container" *ngIf="_tabUI.figures.isSelected">
        <div class="figures-content" [class.gray-out]="_isInputActive">
          <div class="figures-content-main" *ngIf="!_tabUI.figures.isLoading">
            <div
              infiniteScroll
              [infiniteScrollDistance]="1"
              [infiniteScrollThrottle]="500"
              (scrolled)="onFiguresScroll()"
            >
              <div
                *ngFor="let figure of _figures; let i = index"
                [style.margin]="i === 0 ? '10px' : '0 10px 10px 10px'"
              >
                <ddc-content-card
                  [content]="figure"
                  (bookmarkChanged)="updateFigureBookmark($event, i)"
                  (clicked)="openReadDialog('figures', i)"
                ></ddc-content-card>
              </div>
            </div>
            <!-- Info at bottom -->
            <div class="figure-info-label" *ngIf="_totalCounts['figures'] > 10">
              <ng-lottie
                *ngIf="!_tabUI.figures.end && !_tabUI.figures.scrollLoading"
                width="30px"
                [options]="scroll_options"
              ></ng-lottie>
              <ng-lottie *ngIf="_tabUI.figures.scrollLoading" width="50px" [options]="loading_options"></ng-lottie>
              <mat-icon *ngIf="_tabUI.figures.end && !_tabUI.figures.scrollLoading">fact_check</mat-icon>&nbsp;&nbsp;{{
                _tabUI.figures.pageInfoLabel
              }}
            </div>
            <!-- No _figures -->
            <ddc-not-available *ngIf="_figures.length === 0" [_elem]="'Figure'"></ddc-not-available>
          </div>
        </div>
        <div class="elem-skeletons" *ngIf="_tabUI.figures.isLoading">
          <ddc-loading-skeleton></ddc-loading-skeleton>
        </div>
        <div *ngIf="_tabUI.figures.isEmpty">{{ _tabUI.figures.fetchError }}</div>
      </div>
      <!-- ! Categories -->
      <div class="cats-container" *ngIf="_tabUI.categories.isSelected">
        <!-- ! Cats content -->
        <div class="cats-content" [class.gray-out]="_isInputActive">
          <div *ngIf="!_tabUI.categories.isLoading">
            <div
              class="cats-content-main"
              infiniteScroll
              [infiniteScrollDistance]="1"
              [infiniteScrollThrottle]="500"
              (scrolled)="onCatsScroll()"
            >
              <ddc-cat-button
                class="lib_cat_btn"
                *ngFor="let cat of _categories"
                [_label]="cat.label"
                (click)="openEditDialog('category', cat)"
              ></ddc-cat-button>
            </div>
            <!-- Info at bottom -->
            <div class="cat-info-label" *ngIf="_totalCounts['categories'] > 50">
              <ng-lottie
                *ngIf="!_tabUI.categories.end && !_tabUI.categories.scrollLoading"
                width="30px"
                [options]="scroll_options"
              ></ng-lottie>
              <ng-lottie *ngIf="_tabUI.categories.scrollLoading" width="50px" [options]="loading_options"></ng-lottie>
              <mat-icon *ngIf="_tabUI.categories.end && !_tabUI.categories.scrollLoading">fact_check</mat-icon
              >&nbsp;&nbsp;{{ _tabUI.categories.pageInfoLabel }}
            </div>
            <!-- No cats -->
            <ddc-not-available *ngIf="_totalCounts['categories'] == 0" [_elem]="'Category'"></ddc-not-available>
          </div>
        </div>
        <!-- ! Cats loading -->
        <div class="square-divs" *ngIf="_tabUI.categories.isLoading" style="display: flex">
          <ddc-loading-skeleton></ddc-loading-skeleton>
        </div>
        <div *ngIf="_tabUI.categories.isEmpty">{{ _tabUI.categories.fetchError }}</div>
      </div>
      <!-- ! Tags -->
      <div class="tags-container" *ngIf="_tabUI.tags.isSelected">
        <!-- ! Tags content -->
        <div class="tags-content" [class.gray-out]="_isInputActive">
          <div *ngIf="!_tabUI.tags.isLoading">
            <div
              class="tags-content-main"
              infiniteScroll
              [infiniteScrollDistance]="1"
              [infiniteScrollThrottle]="500"
              (scrolled)="onTagsScroll()"
            >
              <ddc-tag-button
                class="lib_tag_btn"
                *ngFor="let tag of _tags"
                [_label]="tag.label"
                (click)="openEditDialog('tag', tag)"
              ></ddc-tag-button>
            </div>
            <!-- Info at bottom -->
            <div class="tag-info-label" *ngIf="_totalCounts['tags'] > 50">
              <ng-lottie
                *ngIf="!_tabUI.tags.end && !_tabUI.tags.scrollLoading"
                width="30px"
                [options]="scroll_options"
              ></ng-lottie>
              <ng-lottie *ngIf="_tabUI.tags.scrollLoading" width="50px" [options]="loading_options"></ng-lottie>
              <mat-icon *ngIf="_tabUI.tags.end && !_tabUI.tags.scrollLoading">fact_check</mat-icon>&nbsp;&nbsp;{{
                _tabUI.tags.pageInfoLabel
              }}
            </div>
            <ddc-not-available *ngIf="_totalCounts['tags'] == 0" [_elem]="'Tag'"></ddc-not-available>
          </div>
        </div>
        <!-- ! Tags loading -->
        <div class="square-divs" *ngIf="_tabUI.tags.isLoading" style="display: flex">
          <ddc-loading-skeleton></ddc-loading-skeleton>
        </div>
        <div *ngIf="_tabUI.tags.isEmpty">{{ _tabUI.tags.fetchError }}</div>
      </div>

      <!-- ! PDFs -->
      <div class="tags-container" *ngIf="_tabUI.pdfs.isSelected">
        <!-- ! PDFs content -->
        <div class="pdfs-content" [class.gray-out]="_isInputActive">
          <div *ngIf="!_tabUI.pdfs.isLoading">
            <div
              class="tags-content-main"
              infiniteScroll
              [infiniteScrollDistance]="1"
              [infiniteScrollThrottle]="500"
              (scrolled)="onPDFsScroll()"
            >
              <ddc-pdf-button class="lib_pdf_btn" *ngFor="let pdf of _pdfs" [pdf]="pdf"></ddc-pdf-button>
            </div>
            <!-- Info at bottom -->
            <div class="tag-info-label" *ngIf="_totalCounts['pdfs'] > 50">
              <ng-lottie
                *ngIf="!_tabUI.pdfs.end && !_tabUI.pdfs.scrollLoading"
                width="30px"
                [options]="scroll_options"
              ></ng-lottie>
              <ng-lottie *ngIf="_tabUI.pdfs.scrollLoading" width="50px" [options]="loading_options"></ng-lottie>
              <mat-icon *ngIf="_tabUI.pdfs.end && !_tabUI.pdfs.scrollLoading">fact_check</mat-icon>&nbsp;&nbsp;{{
                _tabUI.pdfs.pageInfoLabel
              }}
            </div>
            <ddc-not-available *ngIf="_pdfs.length === 0" [_elem]="'PDF'"></ddc-not-available>
          </div>
        </div>
        <!-- ! PDFs loading -->
        <div class="square-divs" *ngIf="_tabUI.pdfs.isLoading" style="display: flex">
          <ddc-loading-skeleton></ddc-loading-skeleton>
        </div>
        <div *ngIf="_tabUI.pdfs.isEmpty">{{ _tabUI.pdfs.fetchError }}</div>
      </div>
    }
  </div>
</div>
